import React, { useEffect, useState } from 'react';
import { track } from '../helpers/analytics';
import { getPlatform } from '../helpers/platform';
import { t } from '../i18n';
import './AppBanner.scss';

const DISMISSED_KEY = 'app-banner-dismissed';
export const APP_BANNER_DISMISSED_EVENT = 'app-banner-dismissed';

export const APP_STORE_URL = 'https://apps.apple.com/app/id6761335656';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=dev.arklay.painttheworld';

const AppBanner = () => {
    const [dismissed, setDismissed] = useState(
        () => sessionStorage.getItem(DISMISSED_KEY) === '1'
    );

    const platform = getPlatform();

    useEffect(() => {
        if (dismissed) return;
        track('app_banner_shown', { platform });
    }, [dismissed, platform]);

    if (dismissed) return null;

    const handleDismiss = () => {
        track('app_banner_dismissed', { platform });
        sessionStorage.setItem(DISMISSED_KEY, '1');
        setDismissed(true);
        window.dispatchEvent(new Event(APP_BANNER_DISMISSED_EVENT));
    };

    const showIos = platform === 'ios' || platform === 'other';
    const showAndroid = platform === 'android' || platform === 'other';

    return (
        <div className="app-banner" role="banner" data-testid="app-banner">
            <img
                className="app-banner__icon"
                src={`${process.env.PUBLIC_URL}/icon/android-chrome-192x192.png`}
                alt=""
                aria-hidden="true"
            />
            <span className="app-banner__text">
                <strong>Paint the World</strong> — {t('web.banner.getTheApp')}
            </span>
            <div className="app-banner__actions">
                {showIos && (
                    <a
                        href={APP_STORE_URL}
                        className="app-banner__store-btn"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={t('web.banner.downloadAppStore')}
                        onClick={() => track('app_banner_store_clicked', { store: 'app_store', platform })}
                    >
                        App Store
                    </a>
                )}
                {showAndroid && (
                    <a
                        href={PLAY_STORE_URL}
                        className="app-banner__store-btn"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={t('web.banner.getOnGooglePlay')}
                        onClick={() => track('app_banner_store_clicked', { store: 'play_store', platform })}
                    >
                        Google Play
                    </a>
                )}
            </div>
            <button
                className="app-banner__dismiss"
                onClick={handleDismiss}
                aria-label={t('web.banner.dismiss')}
                data-testid="app-banner-dismiss"
            >
                ✕
            </button>
        </div>
    );
};

export default AppBanner;
